<div class="animate__animated animate__fadeInRight">
  <div class="row container-fluid">
      <div class="col-12">
          <mat-card class="mat_card_trabajadores p-5">
              <h1 class>Ficha de colaboradores nuevos</h1>
          </mat-card>
      </div>
      <div class="col-12">
          <mat-card class="mat-elevation-z0 mat_card_trabajadores_content">
              <div class="overflow-hidden">
                  <app-lista-fichas></app-lista-fichas>
              </div>
          </mat-card>
      </div>
  </div>
</div>
